// extracted by mini-css-extract-plugin
export var button = "_6o-0";
export var icon = "_6o-1";